"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextmenuType;
(function (ContextmenuType) {
    ContextmenuType[ContextmenuType["header"] = 'header'] = "header";
    ContextmenuType[ContextmenuType["body"] = 'body'] = "body";
})(ContextmenuType = exports.ContextmenuType || (exports.ContextmenuType = {}));
//# sourceMappingURL=contextmenu.type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-datatable/release/types/contextmenu.type.js
// module id = 618
// module chunks = 0